export default {
  regular: {
    minHeight: "75px !important",
  },
};
